const AddIcon = ({className} : {className?:string;}) => {
  return (
<svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12.6411 5.81095C12.6411 5.45591 12.3533 5.16809 11.9982 5.16809C11.6432 5.16809 11.3554 5.45591 11.3554 5.81095V12.1681H4.99711C4.64206 12.1681 4.35425 12.4559 4.35425 12.811C4.35425 13.166 4.64206 13.4538 4.99711 13.4538H11.3554V19.8109C11.3554 20.166 11.6432 20.4538 11.9982 20.4538C12.3533 20.4538 12.6411 20.166 12.6411 19.8109V13.4538H18.9971C19.3521 13.4538 19.64 13.166 19.64 12.811C19.64 12.4559 19.3521 12.1681 18.9971 12.1681H12.6411V5.81095Z" fill="currentColor"/>
</svg>
  )
}

export default AddIcon